// extracted by mini-css-extract-plugin
export default {"red01":"#DD3A59","white01":"#ffffff","badge":"BadgeLight__badge___dmf2u","newBadge":"BadgeLight__newBadge___JKu1P","lowCount":"BadgeLight__lowCount___vFutd"};